import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { analysisActions, contractReviewerActions } from '../../../actions';
import { contractReviewerConstants } from '../../../constants';
import { Panel, Button, ButtonGroup } from 'react-bootstrap';
import { history } from "../../../helpers";
import LoadingListener from '../../../helpers/loadingListener';
import { LoadingIcon } from '../../LoadingIcon';
import '../../../content/css/PortfolioAnalysis/PortfolioAnalysis.css';
import DocumentsTable from './DocumentsTable';
import ListPagination from '../../Misc/ListPagination';

const NewAnalysisState = {
    PICK_DOCUMENTS: 'PICK_DOCUMENTS',
    PICK_THEME: 'PICK_THEME',
    FINISHED: 'FINISHED'
}

class NewPortfolioAnalysisView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            state: NewAnalysisState.PICK_DOCUMENTS,
            selectedDocuments: [],
            currentTablePage: 1,
            itemsPerPage: 20
        };

        this.loadingListener = new LoadingListener([contractReviewerConstants.GET_DOCUMENTS_LIST_REQUEST]);
    }

    componentDidMount() {
        this.props.requestDocumentsList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.state != this.state.state && this.state.state == NewAnalysisState.FINISHED) {
            history.push(`/reports`);
        }
    }

    handleTablePageUpdate = (page) => {
        this.setState({ currentTablePage: page });
    }

    handleRequestNewPortfolioAnalysis = () => {
        this.setState({ state: NewAnalysisState.FINISHED });
        this.props.requestNewPortfolioAnalysis("Report", `A portfolio report covering ${this.state.selectedDocuments.length} documents.`, this.state.selectedDocuments);
    }

    handleDocumentSelect = (documentId, isSelected) => {
        let { selectedDocuments } = this.state;
        if (isSelected && !selectedDocuments.includes(documentId)) selectedDocuments.push(documentId);
        else if (!isSelected) selectedDocuments = selectedDocuments.filter(id => id !== documentId);

        this.setState({ selectedDocuments });
    }

    handleAllDocumentSelect = () => {
        let { selectedDocuments } = this.state;

        const startIndex = (this.state.currentTablePage - 1) * this.state.itemsPerPage;
        const endIndex = startIndex + this.state.itemsPerPage;

        const documentIds = this.props.documents.slice(startIndex, endIndex).map((x, index) => x.id);

        for (const x in documentIds) {
            let id = documentIds[x];
            if (!selectedDocuments.includes(id)) selectedDocuments.push(id);
        }

        this.setState({ selectedDocuments });
    }

    render() {
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);

        return (
            <div className="portfolio-overview portfolio-analysis">
                {isLoading &&
                    <LoadingIcon isFixed={true} />
                }

                {!isLoading &&
                    <React.Fragment>
                        <h2>Pick documents</h2>
                        <ButtonGroup>
                            <Button className="btn btn-primary" onClick={this.handleRequestNewPortfolioAnalysis}>New analysis</Button>
                        </ButtonGroup>
                        <hr />
                        {this.state.state === NewAnalysisState.PICK_DOCUMENTS &&
                            <React.Fragment>
                                <div className="space-between">
                                    <span className="title">You have selected {this.state.selectedDocuments.length} documents</span>
                                    <ButtonGroup>
                                        <Button className="btn btn-primary" onClick={this.handleAllDocumentSelect}>Select all on page</Button>
                                    </ButtonGroup>
                                </div>
                                <Panel className="documents">
                                    <ListPagination
                                        items={this.props.documents}
                                        itemsPerPage={10}
                                        onPageUpdate={this.handleTablePageUpdate}
                                    >
                                        <DocumentsTable
                                            selectedItems={this.state.selectedDocuments}
                                            onSelect={this.handleDocumentSelect}
                                        />
                                    </ListPagination>
                                </Panel>
                            </React.Fragment>
                        }
                        {this.state.state === NewAnalysisState.PICK_THEME &&
                            <Panel className="documents">
                            </Panel>
                        }
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default connect(
    state => {
        const { contractReviewer, analysis } = state;
        return {
            ...analysis,
            documents: contractReviewer.documents,
            isLoading: contractReviewer.isLoading
        };
    },
    dispatch => bindActionCreators({ ...analysisActions, requestDocumentsList: contractReviewerActions.requestDocumentsList }, dispatch)
)(NewPortfolioAnalysisView);


// WEBPACK FOOTER //
// ./src/components/AnalysisReports/NewPortfolioAnalysis/NewPortfolioAnalysisView.js